export const goToUrl = (url?: string) => {
  if (url) window.location.href = url;
};
